import React from "react";
import rehypeReact from "rehype-react";
import styled from "styled-components";
import Helmet from "../components/allpages/Helmet";
import Lexikon from "../apps/lexikon";
import Vocabularium from "../apps/vocabularium";

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    lexikon: Lexikon,
    vocabularium: Vocabularium
  }
}).Compiler;

const Title = styled.h1``;

const Post = styled.div``;

export default ({ data }) => {
  const post = data.markdownRemark;
  const { title } = post.frontmatter;
  return (
    <div>
      <Helmet data={data} />
      <Title>{title}</Title>
      <Post>{renderAst(post.htmlAst)}</Post>
    </div>
  );
};

export const query = graphql`
  query appQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      frontmatter {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/app.js